module.exports = __webpack_public_path__ + "img/jd.9e5292a6.png";